import { isMobile } from 'mobile-device-detect'
import userAPI from '@/api/user'
import { swalFire } from '@/functions/swalHelper'

export default {
  data () {
    return {
      isMobile,
      isLoading: false,
      isValidPhoneNumber: false,
      updatePhoneNumber: null
    }
  },
  computed: {
    authorization () {
      return this.$store.state.storage.accessToken
    },
    btnSubmitClass () {
      return {
        'pointer-events-none': this.isLoading
      }
    },
    isShownWhatsappInputDialog () {
      return this.$store.state.isShownWhatsappInputDialog
    },
    currentPhoneNumber () {
      return this.$store.state.user.userInfo.phone
    }
  },
  methods: {
    getUpdatedPhoneNumber (value) {
      this.updatePhoneNumber = value
    },
    validatePhoneNumber (value) {
      this.isValidPhoneNumber = value
    },
    getPageName (pageName) {
      const formattedPageName = pageName.toLowerCase()
      const allowedPages = ['profile', 'programmu', 'payment-thankyou-page']

      if (allowedPages.includes(formattedPageName)) {
        return formattedPageName === 'payment-thankyou-page' ? 'payment' : formattedPageName
      }
    },
    async saveSettings (userAction) {
      const isDismissed = userAction === 'dismissed'
      const result = await userAPI.updatePhoneNumber(this.authorization, {
        phone: isDismissed ? this.currentPhoneNumber : this.updatePhoneNumber,
        dismiss: isDismissed ? this.getPageName(this.$route.name) : ''
      })

      if (result?.status === 200) {
        this.$store.commit('TOGGLE_WHATSAPP_INPUT_DIALOG', false)
        this.isLoading = false
      } else {
        this.isLoading = false
        this.showAlert(result?.data)
      }
    },
    showAlert (data) {
      if (!data) return
      swalFire({
        title: `Kode ${data.status}`,
        message: data.message,
        confirmButtonText: 'Mengerti'
      })
    }
  }
}
